export const PRINT_DEFAULT_VALUES = {
    name: "COMPANY_NAME",
    address: {
        JUBAIL: "JUBAIL_BRANCH_ADDRESS",
        YANBU: "YANBU_BRANCH_ADDRESS",
    },
    arabicAddress: {
        JUBAIL: "JUBAIL_BRANCH_ADDRESS_AR",
        YANBU: "YANBU_BRANCH_ADDRESS_AR",
    },
    mail: "COMPANY_EMAIL",
    crNumber: "CR_NUMBER",
    vatNumber: "VAT_NUMBER",
};

export type Branches = "YANBU" | "JUBAIL";
